// Navigation v2 (plan nav-search-2026-10-16): the regrouped header, the five
// tab phone bar, the universal search and the phone Home blocks.
//
// Two switches, read once per page load (src/lib/previewFlag.ts):
//  - VITE_NAV_V2 (build time, default OFF). Exactly "1" or "true" turns it on
//    for everyone. Flipping it is a Vercel env change plus a redeploy.
//  - a per-browser preview override in localStorage (`cb.navV2` = "1" / "0"),
//    which wins over the build default in both directions. Visiting any page
//    with `?nav_v2=1` (or `0`) writes that override, so a phone can opt in
//    without devtools; `?nav_v2=clear` removes it.
//
// Flag OFF is today's navigation exactly: Header, MobileNav and NavMenu keep
// their previous render path untouched. The Scan entry points have their own
// flag on top of this one (src/lib/scanCta.ts).

import { NAV_V2_QUERY_PARAM, NAV_V2_STORAGE_KEY } from './navV2.codes'
import { createPreviewFlag, envOn } from './previewFlag'

export { NAV_V2_QUERY_PARAM, NAV_V2_STORAGE_KEY }

const flag = createPreviewFlag(NAV_V2_STORAGE_KEY, NAV_V2_QUERY_PARAM, envOn(import.meta.env.VITE_NAV_V2))

/** True when this page load renders navigation v2. Stable for the session. */
export function navV2Enabled(): boolean {
  return flag.enabled()
}

/** Test seam: forget the cached answer so the next read re-evaluates. */
export function __resetNavV2ForTests(): void {
  flag.reset()
}
